import langEn from './lang-en';
import langPt from './lang-pt';

export default {
  en: langEn,
  pt: langPt
};


// WEBPACK FOOTER //
// ./src/locales/index.js